// External-Dependencies
import { isUndefined, pickBy } from 'lodash';

// WP-Dependencies
import { Component } from '@wordpress/element';
import { PanelBody, QueryControls } from '@wordpress/components';
import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';
// import { __ } from '@wordpress/i18n';
// import { dateI18n, format, __experimentalGetSettings } from '@wordpress/date';
import { InspectorControls } from '@wordpress/block-editor';
import { withSelect } from '@wordpress/data';
import { decodeEntities } from '@wordpress/html-entities';

//Constants
import {
	MIN_EXCERPT_LENGTH,
	MAX_EXCERPT_LENGTH,
	MAX_POSTS_COLUMNS,
} from './constants';

//"GLOBALS"
const CATEGORIES_LIST_QUERY = {	per_page: -1 };
var activeCategory = {};


export default function saveSocialMediaShare ( props ) {

//	console.log("1-Save");
//	console.log(props);
        
        const { fb_url, tw_url, in_url, className } = props.attributes;

	var finalClass = "socialMedia";
        var finalClassLabel = "socialMediaLabel";

	if (className != undefined) {finalClass = finalClass + " " + className; finalClassLabel = finalClassLabel + " " + className;};

	return(
		<>
                        <h6 class={finalClassLabel}>Beitrag teilen</h6>
			<ul class={finalClass}>
				<li><a class="fb_a_link" href={ fb_url } target="_blank" rel="noopener noreferrer"><i class="fb_link"></i></a></li>
				<li><a class="tw_a_link" href={ tw_url } target="_blank" rel="noopener noreferrer"><i class="tw_link"></i></a></li>
				<li><a class="in_a_link" href={ in_url } target="_blank" rel="noopener noreferrer"><i class="in_link"></i></a></li>
			</ul>
		</>
	);
}




